import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Text } from '@chakra-ui/react';
import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { AppLayoutToolbar } from '@src/components/sco/AppLayout/Toolbar/AppLayoutToolbar.tsx';
import { ContentTrackDashboard } from '@src/components/sco/Education/ContentTrackDetail/ContentTrackDashboard';
import { StepNavigator } from '@src/components/sco/Education/ContentTrackStepDetail/Steps/StepNavigator';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { ContentTrackStep } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import { useRouter } from 'next/router';
import React from 'react';
type CourseToolbarProps = {
  contentTrackSlug?: string;
  contentTrackSectionSlug?: string;
  contentTrackStepSlug?: string;
  isNavPanelOpen?: boolean;
  isAsidePanelOpen?: boolean;
  contentTrackStep: ContentTrackStep;
};

// Define the GraphQL query to get the current step and content track details
const GET_CURRENT_STEP_AND_CONTENT_TRACK = gql`
  query GetCurrentStepAndContentTrack(
    $contentTrackSlug: String!
    $contentTrackSectionSlug: String!
    $contentTrackStepSlug: String!
  ) {
    contentTrackSteps(
      where: {
        parentContentTrackSection: {
          slug: $contentTrackSectionSlug
          parentContentTrack: { slug: $contentTrackSlug }
        }
        slug: $contentTrackStepSlug
      }
    ) {
      id
      title
      parentContentTrackSection {
        id
        title
        slug
        color {
          hex
        }
        parentContentTrack {
          id
          title
          slug
          type
          color {
            hex
          }
        }
      }
    }
  }
`;
export const CourseToolbar = props => {
  const $ = _c(16);
  useParentAppLayout();
  useEducationContext();
  useBreakpointContext();
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = CourseToolbar.queries.contentTrack();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.contentTrackSlug) {
    t1 = {
      variables: {
        contentTrackSlug: props.contentTrackSlug
      }
    };
    $[1] = props.contentTrackSlug;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const courseQuery = useQuery(t0, t1);
  let t2;
  if ($[3] !== router.query.contentTrackSectionSlug || $[4] !== router.query.contentTrackSlug || $[5] !== router.query.contentTrackStepSlug) {
    t2 = {
      contentTrackSlug: router.query.contentTrackSlug,
      contentTrackSectionSlug: router.query.contentTrackSectionSlug,
      contentTrackStepSlug: router.query.contentTrackStepSlug
    };
    $[3] = router.query.contentTrackSectionSlug;
    $[4] = router.query.contentTrackSlug;
    $[5] = router.query.contentTrackStepSlug;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = !router.query.contentTrackStepSlug;
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = {
      variables: t2,
      skip: t3
    };
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    data,
    error
  } = useQuery(GET_CURRENT_STEP_AND_CONTENT_TRACK, t4);
  if (error) {
    console.error("Error loading step:", error);
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Text>Error loading step</Text>;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  const currentContentTrackStep = data?.contentTrackSteps[0];
  const isOnContentTrackStep = !!router.query.contentTrackStepSlug;
  isOnContentTrackStep ? currentContentTrackStep?.parentContentTrackSection?.color?.hex || "#242432" : courseQuery?.data?.contentTrack?.color?.hex || "#242432";
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {};
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== currentContentTrackStep) {
    t6 = currentContentTrackStep && <StepNavigator miniNav={true} beforeNextClick={_temp} beforePreviousClick={_temp2} currentContentTrackStep={currentContentTrackStep} />;
    $[12] = currentContentTrackStep;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <AppLayoutToolbar hideRightToggleButton={true} toggleButtonProps={t5} rightElements={<>{t6}</>} />;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
CourseToolbar.queries = {
  contentTrack: () => gql`
      query ($contentTrackSlug: String) {
        contentTrack(where: { slug: $contentTrackSlug }) {
          id
          slug
          title
          type
          ${ContentTrackDashboard.fragments.ContentTrack()}
        }
      }
    `
};
function _temp() {
  return null;
}
function _temp2() {
  return null;
}